import React, { useRef, useState, useEffect } from 'react'
import classnames from 'classnames'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation } from 'swiper'
import SwiperButton from 'Components/swiper-button'
import Link from 'next/link'
import { IPageConfig } from './popular-model'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { Image } from 'Components/view-image'

SwiperCore.use([Navigation])
interface IProps {
  listData: any
  responsiveType: any
  nav: any
}

export default function RenderItem({
  listData = [],
  responsiveType = 'xl',
  navName = '',
  pageConfig = {},
  renderBrandItem,
  url = '/auto/library/x-x-x-x-x-x-x-x-x-x-x',
  index = 0,
  moreType = 'x',
  nav = '',
}: {
  listData: any[]
  responsiveType: string
  navName?: string
  pageConfig: IPageConfig
  url?: string
  index?: number
  moreType?: string
  nav: string
  renderBrandItem: (item: any, index: number) => React.ReactNode
}) {
  const [page, setpage] = useState(pageConfig[responsiveType]['page'] || 0)
  const [size, setSize] = useState(pageConfig[responsiveType]['size'] || 0)
  const [slideIndex, setSlideIndex] = useState(0)

  useEffect(() => {
    setSlideIndex(0)
    setpage(pageConfig[responsiveType]['page'])
    setSize(pageConfig[responsiveType]['size'])
  }, [responsiveType])

  useEffect(() => {
    setSlideIndex(0)
  }, [listData])

  const computedLink = (nav: string, moreType: string) => {
    if (nav) {
      try {
        // 处理nav
        // &country=3
        // &price=10,15
        const [key, param] = nav.slice(1).split('=')
        if (key && param) {
          if (key === 'country') {
            return `/auto/library/x-${moreType}-${param}-x-x-x-x-x-x-x-x`
          }
          if (key === 'price') {
            // '-1 需要转为 !1'
            const newParam = param?.replace('-', '!')
            return `/auto/library/${newParam}-${moreType}-x-x-x-x-x-x-x-x-x`
          }
        }
      } catch (error) {
        console.error(error)
      }
    }

    return `/auto/library/x-${moreType}-x-x-x-x-x-x-x-x-x`
  }

  return (
    <div className={`renderItem-list-wrap`} key={`${url}-${index}`}>
      {listData?.length && (
        <div className="renderItem-list" key={`item-list-`}>
          <div className="renderItem-title">
            <Link
              href={computedLink(nav, moreType)}
              as={computedLink(nav, moreType)}
            >
              <a
                target="_blank"
                className="g-active-link-text"
                onClick={() => {
                  sendTeaCommEvent('clk_event', {
                    event_id: 'select_module_left_nav',
                    button_name: navName,
                    module_id: 'select_module',
                  })
                }}
              >
                {navName}
              </a>
            </Link>
          </div>
          <div className="box clearfix">
            <>
              {new Array(page)
                .fill(undefined)
                .map((item: number, index: number) => {
                  const currentIndex = index * size
                  let currentList = listData.slice(
                    currentIndex,
                    currentIndex + size
                  )
                  if (currentIndex + size > listData.length) {
                    currentList = listData.slice(-size)
                  }
                  return (
                    <div
                      key={`list-item-${index}`}
                      className={classnames(
                        `
                        list-item-wrap
                        tw-grid 
                        tw-gap-12 
                        tw-grid-cols-${pageConfig['sm']['size']}
                        md:tw-grid-cols-${pageConfig['md']['size']}
                        xl:tw-grid-cols-${pageConfig['xl']['size']} 
                        2xl:tw-grid-cols-${pageConfig['2xl']['size']}`,
                        {
                          active: index === slideIndex,
                        }
                      )}
                    >
                      {currentList?.map((item: any, index: number) => {
                        return <>{renderBrandItem(item, index)}</>
                      })}
                    </div>
                  )
                })}
            </>
            <SwiperButton
              className={slideIndex <= 0 ? 'swiper-button-disabled' : ''}
              onClick={() => {
                setSlideIndex((prev) => {
                  if (prev <= 0) {
                    return 0
                  }
                  sendTeaCommEvent('clk_event', {
                    event_id: 'select_module_switch_btn',
                    module_id: 'select_module',
                  })
                  return prev - 1
                })
              }}
              theme="gray"
              type="prev"
              buttonStyle={{
                position: 'absolute',
                left: '4px',
                top: '7px',
                zIndex: 9,
              }}
            />
            <SwiperButton
              onClick={() => {
                setSlideIndex((prev) => {
                  if (prev >= page) {
                    return page
                  }
                  sendTeaCommEvent('clk_event', {
                    event_id: 'select_module_switch_btn',
                    module_id: 'select_module',
                  })
                  return prev + 1
                })
              }}
              theme="gray"
              type="next"
              buttonStyle={{
                position: 'absolute',
                right: '15px',
                top: '7px',
                zIndex: 9,
              }}
              className={classnames({
                'tw-hidden': slideIndex + 1 >= page,
              })}
            />
            <span
              className={classnames({
                'cus-button-next-click': true,
                'tw-hidden': !(slideIndex + 1 >= page),
              })}
            >
              <Link
                href={computedLink(nav, moreType)}
                as={computedLink(nav, moreType)}
              >
                <a
                  target="_blank"
                  className="g-active-link-text"
                  onClick={() => {
                    sendTeaCommEvent('clk_event', {
                      event_id: 'select_module_switch_btn',
                      module_id: 'select_module',
                    })
                  }}
                >
                  更多
                </a>
              </Link>
            </span>
          </div>
        </div>
      )}
      <style jsx>
        {`
          .renderItem-list-wrap {
            position: relative;
            height: 60px;
          }
          .renderItem-list {
            display: flex;
          }
          .renderItem-list.active {
            opacity: 1;
          }
          .renderItem-title {
            width: 45px;
            padding: 10px 0 0 0;
            font-size: 16px;
            color: #1f2129;
          }
          .box {
            flex: 1;
            overflow: hidden;
            height: 58px;
            position: relative;
          }
          .list-item-wrap {
            margin: 0 56px;
            opacity: 0;
            transition: opacity 0.3s ease-in-out;
            position: absolute;
            top: 0;
            right: 0;
            left: 0;
            bottom: 0;
          }
          .list-item-wrap.active {
            opacity: 1;
            z-index: 9;
          }
        `}
      </style>
    </div>
  )
}
